<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <header class="card-header">
            <div class="d-flex">
              <strong class="align-self-center">Banco de dados Arbóreo</strong>

              <a
                v-permission="'Usuario.Adicionar'"
                class="ml-auto btn btn-primary"
                href="/#/densidade-carbono/novo"
                title="Adicionar uma nova espécie"
              >
                Adicionar
              </a>
            </div>
          </header>
          <div v-if="loading" class="loading-container">
            <RotateSquare
              class="loading-position animated fadeIn"
              size="60px"
            ></RotateSquare>
          </div>
          <div v-else class="card-body">
            <div class="row d-flex">
              <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                <div class="form-group">
                  <label for="">Nome</label>
                  <input
                    class="form-control"
                    type="text"
                    v-model="filter.name"
                  />
                </div>
              </div>
              <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-4">
                <button class="btn btn-secondary" @click="Filter">
                  Filtrar
                </button>
              </div>
            </div>
            <b-table
              :hover="true"
              responsive
              :items="itens"
              :fields="fields"
              striped
              :per-page="itensPorPagina"
              show-empty
              empty-text="Nenhuma densidade de carbono encontrado."
            >
              <template v-slot:empty="scope">
                <h4>{{ scope.emptyText }}</h4>
              </template>
              <template v-slot:cell(ativo)="data">
                <div class="center">
                  <span v-if="data.item.ativo" class="badge badge-success">
                    Sim
                  </span>
                  <span v-else class="badge badge-secondary">Não</span>
                </div>
              </template>
              <template v-slot:cell(acoes)="data">
                <div class="btn-group-sm">
                  <b-button
                    variant="warning"
                    style="margin-right: 10px"
                    title="Editar"
                    @click="Editar(data.item)"
                  >
                    <i class="fa fa-edit"></i>
                  </b-button>
                  <b-button
                    variant="danger"
                    title="Remover"
                    @click="Remover(data.item)"
                    v-permission="'Carbono.Remover'"
                  >
                    <i class="fas fa-trash-alt"></i>
                  </b-button>
                </div>
              </template>
            </b-table>
            <b-pagination
              v-model="pagina"
              :total-rows="total"
              :per-page="itensPorPagina"
              align="right"
              size="md"
              class="mt-2"
            ></b-pagination>
            <b-modal
              v-model="modalRemover"
              title="Confirmar exclusão"
              class="modal-danger"
              ok-variant="danger"
              @ok="ModalOk"
              @hidden="ModalCancel"
            >
              Você confirma a exclusão desse registro?
            </b-modal>
            <div class="row no-print">
              <div class="col-sm-12 col-md-5 col-lg-5 col-xl-5">
                <div class="form-group">
                  <label for>Atualizar</label>
                  <b-form-file
                    v-model="file"
                    :state="Boolean(file)"
                    placeholder="Planilha..."
                    accept=".csv"
                    browse-text="Procurar"
                  ></b-form-file>
                </div>
              </div>
              <div class="col" v-if="allItens && allItens.length > 0">
                <div class="form-group">
                  <download-csv
                    title="Baixar dados planilha"
                    :data="GetCsv()"
                    class="btn mt-4"
                    :separator-excel="false"
                    :name="'densidades.csv'"
                  >
                    <i class="fas fa-file-excel fa-2x"></i>
                  </download-csv>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import RotateSquare from "../../components/RotateSquare";
import CarbonService from "../../servico/CarbonService";
import Format from "../../util/Format";

export default {
  name: "Carbon",
  components: {
    RotateSquare
  },
  data() {
    return {
      modalRemover: false,
      itemRemover: null,
      loading: false,
      itens: [],
      allItens: [],
      pagina: 1,
      total: 0,
      itensPorPagina: 20,
      file: null,
      filter: { name: "", page: 1, perPage: 25 },
      fields: [
        { key: "commonName", label: "Nome Comum", sortable: true },
        { key: "scientificName", label: "Nome Científico", sortable: true },
        {
          key: "density",
          label: "Densidade da Madeira (g/cm³)",
          sortable: false
        },
        { key: "obs", label: "Observações", sortable: false },

        {
          key: "acoes",
          label: "Ações",
          sortable: false,
          thClass: "center, wd-120-px"
        }
      ]
    };
  },
  watch: {
    pagina: function (val) {
      this.filter.page = val;
      this.ObterGrid();
    },
    file: function (val) {
      if (!val) return;

      this.loading = true;
      CarbonService.ReportTableUpdate(val)
        .then((response) => {
          this.loading = false;
          this.file = null;
          this.filter.page = 1;
          this.ObterGrid();
        })
        .catch((erro) => {
          this.loading = false;
          this.file = null;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    }
  },
  async mounted() {
    await this.ObterGrid();
    await this.GetAll();
  },
  methods: {
    Filter() {
      this.ObterGrid();
    },
    Editar(usuario) {
      this.$router.push("/densidade-carbono/editar/" + usuario.id);
    },
    ModalCancel(evento) {
      evento.preventDefault();
      this.itemRemover = null;
    },
    ModalOk(evento) {
      evento.preventDefault();
      this.modalRemover = false;
      if (!this.itemRemover) return;

      CarbonService.Remove(this.itemRemover.id)
        .then(() => {
          this.filter.page = 1;
          this.ObterGrid();
          this.$notify({
            data: ["Densidade carbono removido com sucesso."],
            type: "success",
            duration: 5000
          });
        })
        .catch((erro) => {
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },
    Remover(item) {
      this.modalRemover = true;
      this.itemRemover = item;
    },
    async ObterGrid() {
      this.loading = true;

      CarbonService.GetGrid(this.filter)
        .then((response) => {
          this.loading = false;
          this.itens = response.data.itens;
          this.total = response.data.total;
          this.pagina = response.data.pagina;
          this.itensPorPagina = response.data.itensPorPagina;
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },
    GetAll() {
      CarbonService.GetAll()
        .then((response) => {
          this.allItens = response.data;
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },
    GetCsv() {
      return this.allItens.map((item) => {
        let density = Format.Number(item.density);
        return {
          Id: item.id,
          NomeComum: item.commonName,
          NomeCientifico: item.scientificName,
          Densidade: density,
          Observacao: item.obs
        };
      });
    }
  }
};
</script>
  